import type {Reducer} from 'redux';
import type {EntityLifecycleGoal} from 'src/types/entity-lifecycle-goal';
import type {EntityLifecycleGoalAction} from 'src/action-creators/entity-lifecycle-goal';

import {RECEIVE_ENTITY_LIFECYCLE_GOAL} from 'src/action-creators/entity-lifecycle-goal';


type State = {
  values: Array<EntityLifecycleGoal>;
};

const initialState = {
  values: [],
} as const;

// @ts-expect-error - TS2322 - Type '(state: State | null | undefined, action: EntityLifecycleGoalAction) => State | null' is not assignable to type 'Reducer<State, ReceiveEntityLifecycleGoalAction>'.
const reducer: Reducer<State, EntityLifecycleGoalAction> = (
  // @ts-expect-error - TS2322 - Type '{ readonly values: readonly []; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: EntityLifecycleGoalAction,
) => {
  switch (action.type) {
    case RECEIVE_ENTITY_LIFECYCLE_GOAL:
      return {
        ...state,
        values: action.payload,
      };
  }

  return state;
};

export default reducer;
